import { Stack } from '@fluentui/react'
import { useContext, useEffect, useState } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { AppStateContext } from '#/state'
import styles from './Navbar.module.css'
import { Dialog, TextField } from '@fluentui/react'
import { CopyRegular } from '@fluentui/react-icons'
import VerticallyCenteredModal from '../Modal/Modal'
import useChatHistory from '../ChatHistory/ChatHistoryService'
import { Logo } from './components'
import { dataSources } from './dataSources'
import {config} from '#/config'
import {useLogoNavigationLink} from '#/state/hooks/useLogoNavigationLink'
import { AiFillHome,AiOutlineHistory } from "react-icons/ai";

const BasicExample = () => {
  const appStateContext = useContext(AppStateContext)
  const ui = appStateContext?.state.frontendSettings?.ui
  const [hideHistoryLabel, setHideHistoryLabel] = useState<string>('Hide chat history')
  const [showHistoryLabel, setShowHistoryLabel] = useState<string>('Show chat history')
  const [modalShow, setModalShow] = useState<boolean>(false)
  const [isSharePanelOpen, setIsSharePanelOpen] = useState<boolean>(false)
  const [copyClicked, setCopyClicked] = useState<boolean>(false)
  const [copyText, setCopyText] = useState<string>('Copy URL')
  const [shareLabel, setShareLabel] = useState<string | undefined>('Share')
  const chatHistory = useChatHistory()
  const { disableLogoNavigationLink, enableLogoNavigationLink } = useLogoNavigationLink()
  const agentmode = config.env.NEW_ARCHITECT_LIVE

  console.log('agentmode:', agentmode)

  useEffect(() => {
    if (agentmode) {
      disableLogoNavigationLink()
    } else {
      enableLogoNavigationLink()
    }
  },[])


  const handleShareClick = () => {
    setIsSharePanelOpen(true)
  }

  const handleSharePanelDismiss = () => {
    setIsSharePanelOpen(false)
    setCopyClicked(false)
    setCopyText('Copy URL')
  }

  const handleCopyClick = () => {
    navigator.clipboard.writeText(window.location.href)
    setCopyClicked(true)
  }

  const handleHistoryClick = () => {
    appStateContext?.dispatch({ type: 'TOGGLE_CHAT_HISTORY' })
  }

  useEffect(() => {
    if (copyClicked) {
      setCopyText('Copied URL')
    }
  }, [copyClicked])

  useEffect(() => {}, [appStateContext?.state.isCosmosDBAvailable.status])

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 480) {
        setShareLabel(undefined)
        setHideHistoryLabel('Hide history')
        setShowHistoryLabel('Show history')
      } else {
        setShareLabel('Share')
        setHideHistoryLabel('Hide chat history')
        setShowHistoryLabel('Show chat history')
      }
    }

    window.addEventListener('resize', handleResize)
    handleResize()

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    if (appStateContext?.state.isChatHistoryOpen) {
      chatHistory.fetchChatHistory()
    }
  }, [appStateContext?.state.isChatHistoryOpen])

  const OpenMailClient = () => {
    window.open('mailto:akira@hitachienergy.com')
  }

  const OpenExtLink = () => {
    window.open(
      'https://hitachipowergrids.sharepoint.com/:f:/r/sites/Akira/Shared%20Documents/Materials?csf=1&web=1&e=MmiHUt'
    )
  }

  const OpenDataSources = () => {
    window.open(
      'https://hitachipowergrids.sharepoint.com/:x:/r/sites/PM_Intelligent_Assistant/Shared%20Documents/Data%20Sources.xlsx?d=wbd7dbf578cbb47b3a60a0a184af18c89&csf=1&web=1&e=dbSSym'
    )
  }

  return (
    <div>
    {
      agentmode ?
      <Row className={styles.row}>
        <Col className="col-sm-12">
          <nav className={['navbar', 'navbar-expand-lg', 'navbar-light', styles.navbar].join(' ')}>
            <ul className={styles.navbar_nav}>
              <li className={styles.nav_links}>
                <a className={styles.nav_link} href="#" onClick={handleHistoryClick}>
                  {appStateContext?.state?.isChatHistoryOpen ? hideHistoryLabel : showHistoryLabel}
                </a>
              </li>
            </ul>
          </nav>
        </Col>
      </Row>
      :
      <Row className={styles.row}>
        <Col className={styles.colsm3}>
          <Logo />
        </Col>
        <Col className="col-sm-4 text-center">{/* <h1 className="project_head">Akira</h1> */}</Col>
        <Col className="col-sm-5">
          <nav className={['navbar', 'navbar-expand-lg', 'navbar-light', styles.navbar].join(' ')}>
              <ul className={styles.navbar_nav}>
                <li className={styles.nav_links}>
                  <a className={styles.nav_link} href="#" onClick={() => setModalShow(true)}>
                    Data Sources
                  </a>
                </li>
                <li className={styles.nav_links}>
                  <a className={styles.nav_link} href="#" onClick={OpenMailClient}>
                    Give Us Feedback
                  </a>
                </li>
                <li className={styles.nav_links}>
                  <a className={styles.nav_link} href="#" onClick={OpenExtLink}>
                    Prompting Tips
                  </a>
                </li>
                <li className={styles.nav_links}>
                  <a className={styles.nav_link} href="#" onClick={handleHistoryClick}>
                    {appStateContext?.state?.isChatHistoryOpen ? hideHistoryLabel : showHistoryLabel}
                  </a>
                </li>
                <li className={styles.nav_links}>
                  <a className={styles.nav_link} href="#" onClick={handleShareClick}>
                    Share
                  </a>
                </li>
              </ul>
          </nav>
        </Col>
      </Row>
    }
      <Dialog
        onDismiss={handleSharePanelDismiss}
        hidden={!isSharePanelOpen}
        styles={{
          main: [
            {
              selectors: {
                ['@media (min-width: 480px)']: {
                  maxWidth: '600px',
                  background: '#FFFFFF',
                  boxShadow: '0px 14px 28.8px rgba(0, 0, 0, 0.24), 0px 0px 8px rgba(0, 0, 0, 0.2)',
                  borderRadius: '8px',
                  maxHeight: '200px',
                  minHeight: '100px'
                }
              }
            }
          ]
        }}
        dialogContentProps={{
          title: 'Share the web app',
          showCloseButton: true
        }}>
        <Stack horizontal verticalAlign="center" style={{ gap: '8px' }}>
          <TextField className={styles.urlTextBox} defaultValue={window.location.href} readOnly />
          <div
            className={styles.copyButtonContainer}
            role="button"
            tabIndex={0}
            aria-label="Copy"
            onClick={handleCopyClick}
            onKeyDown={e => (e.key === 'Enter' || e.key === ' ' ? handleCopyClick() : null)}>
            <CopyRegular className={styles.copyButton} />
            <span className={styles.copyButtonText}>{copyText}</span>
          </div>
        </Stack>
      </Dialog>

      <VerticallyCenteredModal show={modalShow} onHide={() => setModalShow(false)} items={dataSources} />
    </div>
  )
}

export default BasicExample
